/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneBreakingNews from 'base/components/standalone/BreakingNews';

export const DynamicStandaloneBreakingNews = StandaloneBreakingNews;
export type DynamicStandaloneBreakingNewsProps = PropsFromComponent<typeof StandaloneBreakingNews>;

export const DynamicStandaloneBreakingNewsWith = (extras: DynamicStandaloneExtras): typeof StandaloneBreakingNews => {
    return function DynamicStandaloneBreakingNews(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'BreakingNews');
        return <StandaloneBreakingNews {...mergeProps({ options: { theme } }, props)} />;
    }
}